import { uiText, useUiLanguage } from '@/i18n/interface';
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  useUiLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // Handle common route variations and redirect appropriately
    const pathname = location.pathname.toLowerCase();

    if (pathname === "/admindashboard" || pathname === "/admin-dashboard") {
      console.log("Redirecting /admindashboard to /admin");
      navigate("/admin", { replace: true });
      return;
    }

    if (pathname === "/studentdashboard" || pathname === "/student-dashboard") {
      console.log("Redirecting /studentdashboard to /student");
      navigate("/student", { replace: true });
      return;
    }
  }, [location.pathname, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">{uiText("Oops! Page not found")}</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          {uiText("Return to Home")}</a>
      </div>
    </div>
  );
};

export default NotFound;
